import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper, { isCardTypeJoker } from '../CardStateHelper';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import CardStateModifierHelper from '../CardStateModifierHelper';
import { SCORE_VALUE_CARD } from '../../../Constants/Score';
import { CardTask } from '../CardTasks';
import BaseModifierBehavior from '../ModifierBehavior/BaseModifierBehavior';
import { getCardSuit } from '../../../Utility/CardsHelper';
import { IGameState } from '../../Game/IGameState';
import { ICardsState, ICardStateData } from '../ICardState';
import CheatsManager from 'CheatsManager';
import { CardState } from 'Prototype/Level/Card/CardState';

export default class GoldCardBehavior extends BaseCardBehavior {
    public isPlayable(state: ICardsState): boolean {
        const cardState = CardStateHelper.getCardState(state, this.cardID);
        if (cardState === CardState.IN_PLAY) {
            return (
                super.isPlayable(state) &&
                this.isMatch(state, CardStateHelper.getCurrentCard(state)) &&
                !this.modifiersBlocking(state)
            );
        }
        return super.isPlayable(state);
    }

    public isMatch(state: ICardsState, cardB: string): boolean {
        if (CheatsManager.getFirstInstance()?.shouldIgnoreCardMatchRules()) {
            return true;
        }

        const cardAData: ICardStateData = state.cards[this.cardID];
        const cardBData: ICardStateData = state.cards[cardB];
        // If nothing to match against always match.
        if (!cardBData) {
            return state.inStack.length === 0;
        }

        // If cardB is a joker always match.
        if (isCardTypeJoker(cardBData.type)) return true;

        if (cardBData.type === CardType.gold && cardAData.type === CardType.gold) {
            if (cardBData.suit === cardAData.suit) {
                return true;
            }
        }
        if (cardAData.type === CardType.gold && cardBData.type === CardType.value) {
            if (cardAData.suit === getCardSuit(cardBData.value)) {
                return true;
            }
        }

        return false;
    }

    public play(state: IGameState) {
        const cardStatus = CardStateHelper.getCardState(state.levelState.cardsState, this.cardID);
        let cardsState: ICardsState = state.levelState.cardsState;
        switch (cardStatus) {
            case CardState.IN_PLAY:
                const modBehaviors = this.modifiersOverriding(state.levelState.cardsState);
                console.log(modBehaviors);
                // Modifiers can override the default 'play' method.
                if (modBehaviors.length > 0) {
                    // Modifiers are played instead.
                    for (let i = 0, n = modBehaviors.length; i < n; i++) {
                        state = CardStateModifierHelper.playModifier(
                            state,
                            modBehaviors[i].modifier,
                            modBehaviors[i].cardID
                        );
                    }
                    cardsState = CardStateHelper.getCardsState(state);
                } else {
                    cardsState = CardStateHelper.pushUndoHistory(cardsState, this.cardID, CardState.IN_PLAY);
                    cardsState = CardStateHelper.increaseStreak(cardsState, SCORE_VALUE_CARD, this.cardID);
                    const cardScore = state.levelState.cardsState.streakScore;
                    cardsState = CardStateHelper.addTurnScore(cardsState, cardScore);
                    state = CardStateHelper.updateGameState(state, cardsState);
                    state = CardStateModifierHelper.updateModifiers(state, this.cardID);
                    cardsState = CardStateHelper.getCardsState(state);
                    cardsState = CardStateHelper.setCardFolded(cardsState, this.cardID);
                    cardsState = CardStateHelper.setStateTaskData(cardsState, {
                        task: CardTask.MATCH,
                        cards: [this.cardID],
                        cardScore: cardScore,
                    });
                    cardsState = CardStateHelper.updateCards(cardsState);
                    cardsState = CardStateModifierHelper.onCardPlayed(cardsState, this.cardID);

                    // SOFA-2464, fixme: this is suboptimal
                    state = CardStateHelper.updateGameState(state, cardsState);
                    cardsState = CardStateHelper.checkStreakBonus(state);

                    break;
                }

            case CardState.IN_STACK:
            case CardState.FOLDED:
            case CardState.DISCARDED:
            case CardState.UNKNOWN:
        }

        return {
            ...state,
            levelState: {
                ...state.levelState,
                cardsState,
            },
        };
    }
}
